import jaJson from "./json/csv_ja.json";
import enJson from "./json/csv_en.json";

// cookieへ保存するためのkey名
const COOKIE_KEY_NAME = "zirlang";
// cookie保存期間。とりあえず7日間保存(仮)
const COOKIE_EXPIRES_DATE = 7;

export class LanguageUtils {
  // Cookie設定
  static setCookie = (value: string) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_EXPIRES_DATE);
    document.cookie = `${COOKIE_KEY_NAME}=${value};expires=${expires.toUTCString()};path=/`;
  };

  // Cookie取得
  static getCookie = (): string | null => {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === COOKIE_KEY_NAME) return value;
    }
    return null;
  };

  // 設定されている言語に応じた言語データ取得
  static getLanguageData = () => {
    let lang = LanguageUtils.getCookie();
    if (lang == "en")
    {
      return enJson;
    }
    else if (lang == "ja")
    {
      return jaJson;
    }
    else
    {
      
      // クッキー未設定の場合はブラウザに設定されている言語を確認する
      // 日本語以外は英語として扱う
      if (navigator.language != "ja")
      {
        return enJson;
      }
      else
      {
        return jaJson;
      }
    }
  };

  // 設定されている言語に応じた言語文字列を取得
  static getLanguage = () : string => {
    let lang = LanguageUtils.getCookie();
    if (lang == "en")
    {
      return "en";
    }
    else if (lang == "ja")
    {
      return "ja";
    }
    else
    {
      // クッキー未設定の場合はブラウザに設定されている言語を確認する
      // 日本語以外は英語として扱う
      if (navigator.language != "ja")
      {
        return "en";
      }
      else
      {
        return "ja";
      }
    }
  };
}

